import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Warning: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[32px] h-[32px] stroke-[2px] text-white fill-[#FFD324]', className)}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6533 5.27602L2.42399 24.0227C2.19262 24.4236 2.07023 24.8781 2.06898 25.341C2.06773 25.8039 2.18767 26.2591 2.41687 26.6613C2.64607 27.0635 2.97655 27.3987 3.37545 27.6335C3.77435 27.8684 4.22778 27.9947 4.69065 28H27.1507C27.6135 27.9947 28.067 27.8684 28.4659 27.6335C28.8648 27.3987 29.1952 27.0635 29.4244 26.6613C29.6536 26.2591 29.7736 25.8039 29.7723 25.341C29.7711 24.8781 29.6487 24.4236 29.4173 24.0227L18.1867 5.27602C17.9502 4.88668 17.6174 4.56481 17.2204 4.34144C16.8234 4.11807 16.3755 4.00073 15.92 4.00073C15.4645 4.00073 15.0166 4.11807 14.6196 4.34144C14.2226 4.56481 13.8898 4.88668 13.6533 5.27602Z"
      fill="currentFill"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 10.6667C16.7363 10.6667 17.3333 11.2637 17.3333 12.0001V17.3334C17.3333 18.0698 16.7363 18.6667 16 18.6667C15.2636 18.6667 14.6666 18.0698 14.6666 17.3334V12.0001C14.6666 11.2637 15.2636 10.6667 16 10.6667ZM14.6666 22.6667C14.6666 21.9304 15.2636 21.3334 16 21.3334H16.0133C16.7497 21.3334 17.3466 21.9304 17.3466 22.6667C17.3466 23.4031 16.7497 24.0001 16.0133 24.0001H16C15.2636 24.0001 14.6666 23.4031 14.6666 22.6667Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
  </svg>
);

export default Warning;
